<template>
  <div id="app">
    <router-view v-if="isPk"></router-view>
  </div>
</template>
<script>
// import axios from "axios";
export default {
  data() {
    return {
      isPk: false,
    };
  },
  async created() {
    await this.getPk();
    await this.getWebIp();
  },
  methods: {
    async getPk() {
      let res = await this.$apis.manage.getPk();
      this.isPk = true;
      sessionStorage.setItem("trip", res.pk);
    },
    async getWebIp() {
      try {
        let res = await this.$apis.manage.getUserIpConfig();
        if (res.status === 0) {
          sessionStorage.setItem("webIp", res.result.ip);
        } else {
          sessionStorage.setItem("webIp", "103.43.184.186");
        }
      } catch (error) {
        sessionStorage.setItem("webIp", "103.43.184.186");
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  background: #f1f1f1;
}
</style>
